import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Icon from './Icon';

const Dropdown = forwardRef(({ children, position, align, type, className, withArrow }, ref) => {
  return (
    <Wrapper
      ref={ref}
      position={position}
      align={align}
      type={type}
      className={className}
    >
      {children}

      {withArrow && <Arrow />}
    </Wrapper>
  );
});

export default styled(Dropdown)``;

Dropdown.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  position: PropTypes.oneOf(['top']),
  align: PropTypes.oneOf(['center', 'right']),
  type: PropTypes.oneOf(['tooltip']),
  withArrow: PropTypes.bool,
};

Dropdown.defaultProps = {
  withArrow: false
};

const Arrow = styled.div`
  position: absolute;
  width: 0; 
  height: 0; 
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--lizzy-white);
  top: -6px;
  left: 50%;
  margin-left: -6px;
  z-index: 12;
`;

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 6px;
  background-color: var(--lizzy-white);
  border: 1px solid var(--lizzy-black-10);
  box-shadow: 0px 9px 27px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  z-index: 2;

  ${p => p.position === 'top' && css`
    bottom: 100%;
    margin-bottom: 12px;

    ${Arrow} {
      bottom: -6px;
      top: auto;
      border-top: 6px solid var(--lizzy-white);
      border-bottom: none
    }
  `}

  ${p => p.align === 'center' && css`
    left: 50%;
    transform: translateX(-50%);
  `}

  ${p => p.align === 'right' && css`
    left: auto;
    right: 0;
  `}

  ${p => p.type === 'tooltip' && css`
    border: none;
  `}
`;

export const Item = styled.li`
  all: unset;
  display: flex;
  white-space: nowrap;
  padding: 2px 6px;
  cursor: pointer;
  color: var(--lizzy-black-65);
  align-items: center;

  &:last-child {
    border-radius: 0 0 8px 8px;
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--lizzy-black-10);
  }

  ${p => p.active && css`
    color: var(--lizzy-black);
  `}

  &:hover {
    background-color: var(--lizzy-black-10);
    color: var(--lizzy-black);
  }

  ${Icon} {
    svg {
      width: 22px;
      height: 22px;
    }
  }
`;